import { DS_BADGE_STATE, DSBadgeState } from "@/src/design_system/data_display/badge/types/state";
import { DS_ICON_SIZES, DSIconSize } from "@/src/design_system/primitives/icon/types";
import { DSIconName } from "@/src/design_system/primitives/icon/types/iconName.generated";
import { DS_SIZE } from "@/src/design_system/shared/types/size";
import type { DSBadgeSize } from "@/src/design_system/data_display/badge/types/props";
import { DS_USER_SIZE, DSUserSize } from "@/src/design_system/data_display/user/types/size";
import { DS_USER_STATUS, DSUserStatus } from "@/src/design_system/data_display/user/types/status";

export const DS_USER_AVATAR_ICON_SIZE_MAP: Record<DSUserSize, DSIconSize> = {
  [DS_USER_SIZE.ExtraSmall]: DS_ICON_SIZES.Small,
  [DS_USER_SIZE.Small]: DS_ICON_SIZES.Medium,
  [DS_USER_SIZE.Medium]: DS_ICON_SIZES.Large,
  [DS_USER_SIZE.Large]: DS_ICON_SIZES.Large,
  [DS_USER_SIZE.ExtraLarge]: DS_ICON_SIZES.ExtraLarge,
  [DS_USER_SIZE.ExtraExtraLarge]: DS_ICON_SIZES.ExtraLarge,
};

export const DS_USER_AVATAR_BADGE_SIZE_MAP: Record<DSUserSize, DSBadgeSize> = {
  [DS_USER_SIZE.ExtraSmall]: DS_SIZE.Small,
  [DS_USER_SIZE.Small]: DS_SIZE.Small,
  [DS_USER_SIZE.Medium]: DS_SIZE.Medium,
  [DS_USER_SIZE.Large]: DS_SIZE.Medium,
  [DS_USER_SIZE.ExtraLarge]: DS_SIZE.Medium,
  [DS_USER_SIZE.ExtraExtraLarge]: DS_SIZE.Large,
};

export const DS_USER_STATUS_BADGE_MAP: Record<
  Exclude<DSUserStatus, typeof DS_USER_STATUS.None>,
  {
    state: DSBadgeState;
    disabled: boolean;
    ariaLabelKey: keyof Window["I18n"]["designSystem"]["user"];
    icon: DSIconName;
  }
> = {
  [DS_USER_STATUS.Online]: {
    state: DS_BADGE_STATE.Success,
    disabled: false,
    ariaLabelKey: "statusOnline",
    icon: "check",
  },
  [DS_USER_STATUS.Offline]: {
    state: DS_BADGE_STATE.Neutral,
    disabled: true,
    ariaLabelKey: "statusOffline",
    icon: "cross-small",
  },
  [DS_USER_STATUS.Away]: {
    state: DS_BADGE_STATE.Default,
    disabled: false,
    ariaLabelKey: "statusAway",
    icon: "cross-small",
  },
  [DS_USER_STATUS.DoNotDisturb]: {
    state: DS_BADGE_STATE.Danger,
    disabled: false,
    ariaLabelKey: "statusDnd",
    icon: "cross-small",
  },
};
